import React from 'react';
import { observer } from "mobx-react"
import BackButton from "../../widgets/BackButton";

const TimesheetSubmissionButton = ({ ...props }) => {

    let timesheet = props.store.timesheets.getById(props.timesheetId);

    let isAdmin = props.store.user.isAdmin && timesheet;

    //Admins and students both use this component,
    // but the "back" button should read differently b / c they access it differently.;

    const backButtonInnerText = props.store.user.isAdmin ? "Back to Timesheet" : "Back to Account"


    if (props.mode == "confirm" && timesheet) {
        //Admin view does not have a "back to account" button
        if (isAdmin) {
            if (!timesheet.isCertified) {
                return (
                    <div className="timesheetSubmissionButtons">
                        <BackButton className="btn btn-secondary mr-2 ml-2 float-left" innerText={backButtonInnerText} />
                        <button className="btn btn-secondary mr-2 float-left" type="button" onClick={props.handleChangeMode} disabled={props.isSubmitting}>
                            Edit
                        </button>
                    </div>
                )
            }
            else {
                return (
                    <div className="timesheetSubmissionButtons">
                        <BackButton className="btn btn-secondary mr-2 ml-2" innerText={backButtonInnerText} />
                    </div>
                )
            }
        }


        //If timesheet is saved but not finalized
        if (!timesheet.isFinal) {
            return (
                <div className="timesheetSubmissionButtons">
                    <BackButton className="btn btn-secondary mr-2 ml-2 float-left" innerText={backButtonInnerText} />
                    <button className="btn btn-secondary mr-2 float-left" type="button" onClick={props.handleChangeMode} disabled={props.isSubmitting}>
                        Edit
                    </button>
                    <button className="btn btn-primary float-right" type="button" onClick={props.handleFinalSubmission} disabled={props.isSubmitting} >
                        Submit
                    </button>
                </div>
            )
        }
        //Timesheet is finalized
        else {
            return (
                <div className="timesheetSubmissionButtons">
                    <BackButton className="btn btn-secondary mr-2 ml-2" innerText={backButtonInnerText} />
                </div>
            )
        }
    }
    //Timesheet is in edit mode. 
    else if (props.mode == "mutate") {
        return (
            <div className="timesheetSubmissionButtons">
                <BackButton className="btn btn-secondary mr-2 ml-2 float-left" innerText={backButtonInnerText} />
                <button className="btn btn-secondary ml-2 float-left" type="submit" disabled={props.isSubmitting}>
                    Save & Review
                </button>
            </div>
        )
    }
}

export default observer(TimesheetSubmissionButton);